import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { Offers } from "@/components/Offers";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { HowItWorks } from "@/components/HowItWorks";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import ConditionsGenerales from "@/pages/ConditionsGenerales";
import Quiz from "@/pages/Quiz";

const HomePage = () => (
  <div className="min-h-screen bg-white font-sans text-black antialiased">
    <Header />
    <main>
      <Hero />
      <MarqueeStrip />
      <Offers />
      <Services />
      <WhyUs />
      <HowItWorks />
      <Testimonials />
      <Faq />
      <Contact />
    </main>
    <Footer />
    <FloatingWhatsApp />
    <Toaster position="top-center" richColors />
  </div>
);

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.1, wheelMultiplier: 0.9 }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/conditions-generales" element={<ConditionsGenerales />} />
        </Routes>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
